import { useMutation } from "@tanstack/react-query";
import { resendVerification } from "@/adapters/api";

export function useResendVerification() {
	return useMutation({ mutationFn: resendVerification });
}
